import Toast from 'react-native-root-toast';

export const toast = (msg: string, color: string = '#000') => Toast.show(msg, {position: Toast.positions.TOP, shadow: false, opacity: 0.9, duration: Toast.durations.LONG, backgroundColor: color})